module.exports = __webpack_public_path__ + "media/images/content-icon-sm-ab3dc968be529382a789b0d271acc03e.svg";